import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { WindowService } from '../../services/window-dialogs/window.service';
import { SortBot } from '../../helpers/sort';
import { ActivityItemArray, MemberSectionItem, ActivityItem } from '@models/domain/activity.item';
import * as moment from 'moment';
import { GlobalActivitiesRequest } from '@models/ss-api/requests/global.activities.request';
import { LicenseManager } from 'app/managers/License.manager';
import { regex } from '../../../app/shared/regex';
import { MemberBasicsArray } from '@models/domain/member.basics';
import { ConversationThreadMessageArray } from '@models/domain/conversation.thread.message';
import { ConversationHistoryDialog } from 'app/dialogs/conversation.history/conversation.history.dialog';

@Component({
    selector: 'global-activity-stream',
    templateUrl: './global.activity.stream.component.html',
    styleUrls: ['./global.activity.stream.component.scss']
})
export class GlobalActivityStreamComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    ActivityItems : ActivityItemArray;

    MemberData : MemberBasicsArray;

    resultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;


    
    EndDate: Date = new Date;
    StartDate : Date = new Date;



    constructor(private dialogService: DialogService, private api: ssApiService, private gb: GlobalService, private windowService: WindowService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Global Activity Stream');
        
        // SET UP DATES
        let today = moment();
        this.EndDate = moment(today).toDate()
        this.StartDate = moment(today).subtract(1, 'months').toDate()
        
        this.LoadActivityStream();
    
    }

    

    LoadActivityStream() {
        this.IsBusy = true;

        var request = new GlobalActivitiesRequest();

        request.StartDate = this.StartDate;
        request.EndDate = this.EndDate;

        console.log( request );

        let disposable = this.api.GetGlobalActivities( request ).subscribe(result => {
            disposable.unsubscribe();
            this.IsBusy = false;
            console.log(result.Data);
            this.ActivityItems = result.Data.ActivityItems;
            this.MemberData = result.Data.AssociatedMembers;
            this.AddMembersToActivity();
        });

    }


    AddMembersToActivity() {
        
        let currentID = 0;
        let len = this.ActivityItems.length;

        for( let i = 0; i < len; i++ ) {
            let item = this.ActivityItems[i];

            if( item.Data.MemberID != null || item.Data.MemberID != undefined ) {

                if( item.Data.MemberID != currentID ) {
                    len += 1;
                    currentID = item.Data.MemberID;
                    let newItem = new ActivityItem<MemberSectionItem>();
                    
                    newItem.Data = new MemberSectionItem();
                    
                    newItem.ActivityType = 99;

                    let memberItem = this.MemberData.find( x => x.ID == currentID);

                    if( memberItem != undefined ) {
                        newItem.Data.MemberName = memberItem.Name;
                        newItem.Data.MemberID = memberItem.ID;
                    }

                    this.ActivityItems.splice(i, 0, newItem);

                }

            }

        }

    }


    IsLicenseKey(possibleKey: string) {
        return regex.IsPossibleLicenseKey(possibleKey);
    }

    IsConversationThread(possibleThread: string){
        if (possibleThread){
            return possibleThread.startsWith("CNVTHD-");
        }
    }    

    LicenseClick(key: string): void {
        // var windowSettings = new WindowSettings();
        // windowSettings.Height = 900;
        // windowSettings.Width = 1240;

        // this.windowService.OpenWindow<string>(WindowTypes.License, key, windowSettings);
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(key, true);
        manager.OnChangesSaveResponse.subscribe(response => {})
    }

    onConversationClick(conversationID: string): void {
        this.IsBusy = true;
        let title: string;
        title = "Conversation History";
    
        let options = {
            height: 800
        }

        let data: ConversationThreadMessageArray = [];

        let id = Number(conversationID.replace("CNVTHD-", ""));

        let convoDisposable = this.api.getConversationThreadMessages(id).subscribe(response => {
            data = response.Data;
            convoDisposable.unsubscribe();

            let disposable = this.dialogService.addDialog(ConversationHistoryDialog, {
                title: title,
                subTitle: "",
                message: 'Confirm message',
                conversationMessages: data
            }, options).subscribe(response => {
                disposable.unsubscribe();
                this.IsBusy = false;
            });
    
        });        

    }    

    paginateActivityStream(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    FileNameForPath(path) {
        return path.match(new RegExp(/[^\\]*$/))[0];
    }
    

    // ////////////////////////////////////
    // SORT STUFF
    // ////////////////////////////////////

    //sortByDate() { SortBot.SortAuto(this.FilteredSales, 'DateTimeCreated'); }



}
